import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export const tripGroupFromGroup = (formBuilder: FormBuilder): FormGroup => {
  return formBuilder.group({
    name: ['', { validators: Validators.required}],
    maxPassengers: [null]
  });
};
